import { getUrlWithId, useGetFetch } from '../../utils/reactQuery';
import { pathToUrl } from '../../utils/router';
import { ApiRoutesEnum } from '../../utils/routes';
import { ClientType } from '../clients/Clients.types';

export const useGetClient = (id: string) =>
  useGetFetch<ClientType>({ url: pathToUrl(getUrlWithId(ApiRoutesEnum.getClient, id)), config: { enabled: !!id } });
